module.exports = {"mainbox1Header":"Hjemmesider","mainbox1Text":"Brødtekst","mainbox2Header":"Web platforme","mainbox2Text":"Brødtekst","mainbox3Header":"Mac, Windows & Linux applikationer","mainbox3Text":"Brødtekst","firstServiceHeader":"Service","firstServiceText":"Brødtekst","secondServiceHeader":"Service","secondServiceText":"Brødtekst","readmore":"Læs mere"}


//////////////////
// WEBPACK FOOTER
// ./src/app/service/lang/da.lang.json
// module id = 347
// module chunks = 1